import { render, staticRenderFns } from "./shareQuestionnaire.vue?vue&type=template&id=4776e3de&scoped=true&"
import script from "./shareQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./shareQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./shareQuestionnaire.vue?vue&type=style&index=0&id=4776e3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776e3de",
  null
  
)

export default component.exports